import { useEffect } from 'react';

import { TilePlaceholder } from 'pages/dashboard/components';
import { Card, Image, ListGroup } from 'react-bootstrap';
import { DashboardApi } from 'apis/DashboardApi';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { useSuperState } from 'hooks';
import { ERole } from 'types';
import { useApp } from 'app';

export const LTITile = props => {

    const { highestRole, selectedPartner } = useApp();
    const partnerId = selectedPartner?.id;
    const roleId = highestRole?.id;

    const [state, setState] = useSuperState({
        hasKey: null as boolean | null,
        loading: !!partnerId
    });
    const { hasKey, loading } = state;

    const loadKeyStatus = async () => {

        try {

            const result = await DashboardApi.GetApiKeyStatus(partnerId);
            setState({
                hasKey: result,
                loading: false
            });

        } catch {

            setState({
                hasKey: false,
                loading: false
            });

        }

    };

    useEffect(() => {

        if (![ERole.SYSADMIN, ERole.TESTING_CENTER].includes(roleId) || !partnerId) return;
        loadKeyStatus();

    }, [partnerId, roleId]);

    return (
        <>
            {loading ?
                (
                    <TilePlaceholder icon/>
                )
                :
                (
                    <Card className={'lti-tile overflow-hidden'}>
                        <Card.Header className="text-uppercase">
                            <strong>
                                {<FormattedMessage defaultMessage="Learning Tools Interoperability (LTI)" id="learning_tools_interoperability_lti.291f6761" />}
                            </strong>
                        </Card.Header>

                        <div className={'d-flex'}>
                            <ListGroup className={'flex-fill border-end'} variant="flush">
                                <ListGroup.Item
                                    action
                                    active={false}
                                    href="http://gmetrix.net/documentation/Documents/GMetrixLTIIntegrationV3.pdf"
                                    rel="noreferrer"
                                    target="_blank"
                                >
                                    <i className="fa-solid fa-arrow-up-right-from-square me-2 text-muted" />
                                    {<FormattedMessage defaultMessage="Getting Started With" id="getting_started_with.7fd25331" />}
                                    {' LTI'}
                                </ListGroup.Item>

                                {hasKey !== null && (
                                    <ListGroup.Item action active={false} as={Link} to="/lti-resource-keys">
                                        <i className="fa-solid fa-arrow-up-right-from-square me-2 text-muted" />
                                        {hasKey ?
                                            <FormattedMessage defaultMessage="Resources Key lookup" id="resources_key_lookup.f53edee7" />
                                            :
                                            <FormattedMessage defaultMessage="Request a Key" id="request_a_key.25669329" />
                                        }
                                    </ListGroup.Item>
                                )}

                                <ListGroup.Item action active={false} as={Link} to="/integrations">
                                    <i className="fa-solid fa-arrow-up-right-from-square me-2 text-muted" />
                                    <span>

                                        <FormattedMessage defaultMessage="Integrations" id="integrations.89572b90" />
                                    </span>
                                </ListGroup.Item>
                            </ListGroup>
                            <div
                                style={{
                                    flexShrink: 0,
                                    width: 150
                                }}
                                className={'p-2 d-flex align-items-center justify-content-center bg-light'}
                            >
                                <Image
                                    fluid
                                    src={`${location.origin}/Images/HomeTab/IMSGlobalIconGrey.png`}
                                />
                            </div>
                        </div>
                    </Card>
                )}
        </>
    );

};
